import { render, staticRenderFns } from "./ClientMaterialGroupSettingEdit.vue?vue&type=template&id=a61aaf50&"
import script from "./ClientMaterialGroupSettingEdit.js?vue&type=script&lang=js&"
export * from "./ClientMaterialGroupSettingEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports